<app-content-box theme="white" borderRadius="base-border-radius" padding="p-16" class="full-width">
  <div class="d-flex align-items-center gap-16 justify-content-center p-x-8">
    <div
      contenteditable
      min-width="50px"
      max-width="100%"
      class="h2 fw-medium amount-editable text-center"
      (keydown)="onKeyDown($event)"
      [innerHTML]="value"
    >
    </div>
    <div class="h2 fw-medium">
      @if (inputType === 'percentage') {
        %
      } @else {
        {{ languageConfig.currency.short }}
      }
    </div>
  </div>
</app-content-box>
